import React from 'react';

const SvgAz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path
        d="M15.111 8.337a1.667 1.667 0 1 0 0 3.326 2 2 0 1 1 0-3.326zm.222 2.33a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334z"
        id="AZ_svg__d"
      />
      <filter
        x="-12.5%"
        y="-12.5%"
        width="125%"
        height="150%"
        filterUnits="objectBoundingBox"
        id="AZ_svg__c"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AZ_svg__b" fill="#fff">
        <use xlinkHref="#AZ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#AZ_svg__a" />
      <path fill="#24AAD5" mask="url(#AZ_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#21BF75" mask="url(#AZ_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#ED1845" mask="url(#AZ_svg__b)" d="M0 6.667h28v6.667H0z" />
      <g mask="url(#AZ_svg__b)">
        <use fill="#000" filter="url(#AZ_svg__c)" xlinkHref="#AZ_svg__d" />
        <use fill="#FFF" xlinkHref="#AZ_svg__d" />
      </g>
    </g>
  </svg>
);

export default SvgAz;
